import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

const useStyles = makeStyles(
  theme => ({
    root: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),
      '& .MuiButtonBase-root': {
        color: 'inherit',
      },
    },
  }),
  { name: 'CncUI-TablePaginationActions' },
);

const PaginationActions = props => {
  const classes = useStyles();
  const { page, count, rowsPerPage, onChangePage } = props;

  const handleLastPageButtonClick = event => {
    onChangePage(event, 1);
  };

  const handleBackButtonClick = event => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = event => {
    onChangePage(event, page + 1);
  };

  return (
    <div className={clsx('cncui-table-pagination-actions', classes.root)}>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={count < rowsPerPage}
        title="Get previous health checks"
        aria-label="next page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 1}
        title="Get newer health checks"
        aria-label="previous page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page === 1}
        title="Get latest health checks"
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </div>
  );
};

export default PaginationActions;
